import React from 'react'
import PipesForm from './controller/PipesForm'

interface Props {
    onChangeStr: (field: string, value: string) => void
    onChangeObjConfig: (obj: any) => void
    expression: string
    span: string
    follow: boolean
    provider: string
}

export function MainForm({ expression, onChangeStr, span, follow, onChangeObjConfig, provider }: Props) {
    return (
        <div className="form-group" style={{ width: '713px' }}>
            <PipesForm
                onChange={({ expression, span, provider }) => {                    
                    onChangeObjConfig({
                        expression,
                        queryProvider: provider
                    })
                }}
                follow={follow}
                span={span}
                query={expression}
                provider={provider}
            />
        </div>
    )
}
